var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ItemStatusDomainService from "../../../Domain/ItemStatus/ItemStatus.service";
const ItemStatusBadge = (_a) => {
    var { itemStatus, className } = _a, otherProps = __rest(_a, ["itemStatus", "className"]);
    return (_jsx("span", Object.assign({}, otherProps, { title: itemStatus.description, className: `badge badge-${ItemStatusDomainService.getColor(itemStatus.id)} ${className || ""}`, children: itemStatus.name })));
};
export default ItemStatusBadge;
